import { Epic } from 'redux-observable';
import { switchMap, withLatestFrom, filter } from 'rxjs/operators';
import {
  dashboardViewFetchDashboardRequest,
  dashboardViewInit,
  getDashboardViewIsWithData,
} from '../dashboardViewSlice';
import { RootState } from '../../../../store';
import { routingOnRouteToDashboard } from 'src/app/store/routingSlice';

type IN = ReturnType<typeof dashboardViewFetchDashboardRequest>;
type OUT = ReturnType<typeof dashboardViewInit>;

export const DashboardViewOnRouteEpic: Epic<IN | OUT, OUT, RootState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(routingOnRouteToDashboard.match),
    withLatestFrom(state$),
    switchMap(([, state]) => {
      const isWithData = getDashboardViewIsWithData(state);

      if (isWithData) {
        return [];
      }

      return [dashboardViewInit()];
    }),
  );
